import { request } from './request';

// 描述信息
export interface DescInfo {
  coveImage: string;
  description: string;
  key: string;
}

// 环境展示项
export interface EnvironmentItem {
  id: number;
  url: string;
  key: string;
}

// 产品上新项
export interface NewProductItem {
  id: number;
  url: string;
  key: string;
}

// 湖畔咖啡信息接口响应类型
export interface LakesideCoffeeInfo {
  descInfo: DescInfo;
  environment: EnvironmentItem[];
  newProduct: NewProductItem[];
}

// 通用响应类型
export interface ApiResponse<T = any> {
  code: number;
  data: T;
  msg: string;
  total?: number;
}

/**
 * 获取湖畔咖啡信息
 */
export const getLakesideCoffeeInfo = () => {
  return request.get('/lakeside_coffee/info');
};
